import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

function AdminFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 p-8 text-center"
      role="alert"
    >
      <AlertTriangle className="h-12 w-12 text-destructive" aria-hidden="true" />
      <h2 className="text-xl font-semibold">Something went wrong</h2>
      <p className="max-w-md text-muted-foreground">
        An unexpected error occurred in the Admin Console.
      </p>
      {error instanceof Error && error.message && (
        <p className="max-w-md break-words text-sm text-muted-foreground/70">
          {error.message}
        </p>
      )}
      <div className="flex gap-3">
        <Button variant="outline" onClick={resetErrorBoundary}>
          Retry
        </Button>
        <Button asChild>
          <Link to="/">Return to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
}

export default function AdminErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ErrorBoundary
      FallbackComponent={AdminFallback}
      onError={(error, info) => {
        console.error(
          '[AdminErrorBoundary] Error:',
          error,
          info?.componentStack,
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
